export const WhitelistActionTypes = {
    FETCH_WHITELIST_REQUEST: '@@transaction/FETCH_WHITELIST_REQUEST',
    FETCH_WHITELIST_SUCCESS: '@@transaction/FETCH_WHITELIST_SUCCESS',
    FETCH_WHITELIST_FAILURE: '@@transaction/FETCH_WHITELIST_FAILURE',
}

export const whitelistInitialState = {
    whitelists: [],
    isLoading: false
}